import React, { useEffect } from 'react';
import classnames from 'classnames';
import { Segment, Dimmer, Loader } from 'semantic-ui-react';

import { SemanticPlaceholder } from '../assets/components';

import { useExternalScript } from '../assets/hooks';

export function Highcharts({ data, ...rest }) {
  const { attributes } = data;
  const [ref, loaded, error, setUrl] = useExternalScript('');

  const { className, tagName: Tag, blockClass, highchartsId, anchor } = attributes;

  const blockClasses = classnames(blockClass, className, {});

  useEffect(() => {
    setUrl(`https://app.everviz.com/inject/${highchartsId}/`);
  }, [highchartsId]);

  return (
    <>
      <Tag id={anchor} ref={ref} className={blockClasses}>
        <Dimmer.Dimmable as={Segment} dimmed={!loaded} inverted={error} basic>
          <Dimmer active={!loaded}>
            <Loader>{error ? 'Something went wrong :(' : 'Loading'}</Loader>
          </Dimmer>

          {!loaded && <SemanticPlaceholder inverted={error} />}
          <div id={`highcharts-${highchartsId}`} />
        </Dimmer.Dimmable>
      </Tag>
    </>
  );
}
